import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import React from 'react';
import PropTypes from 'prop-types';
import DelegationService from '../../services/DelegationService';
import ProjectService from '../../services/ProjectService';
import InputAutocompleteComponent from '../../components/inputs/InputAutocompleteComponent';
import {t} from 'i18next';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import InputCalendarComponent from '../../components/inputs/InputCalendarComponent';
import CountryService from '../../services/CountryService';
import DivContainer from '../../components/DivContainer';
import ActionLink from '../../components/ActionLink';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextareaComponent from '../../components/inputs/InputTextareaComponent';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import moment from 'moment';
import Constants from '../../utils/constants';
import StringUtils from '../../utils/StringUtils';
import UrlUtils from '../../utils/UrlUtils';
import YesNoDialog from '../../components/YesNoDialog';
import {DelegationStatus} from '../../model/enum/DelegationStatus';
import {ViewMode} from '../../model/enum/ViewMode';
import DateUtils from '../../utils/DateUtils';
import UsersService from '../../services/UsersService';
import {TabPanel, TabView} from 'primereact/tabview';
import StepperComponent from '../../components/StepperComponent';
import ActionButton from '../../components/ActionButton';
import DelegationDietStep from './DelegationDietStep';
import DelegationTravelCostStep from './DelegationTravelCostStep';
import DictionaryService from '../../services/DictionaryService';
import DelegationSummaryStep from './DelegationSummaryStep';
import { withRouter } from "react-router-dom";

class DelegationContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new DelegationService());
        this.state = {
            activeIndexTabPanel: 0,
            activeSettlementStep: 0,
            editRefund: false,
            loading: true,
            elementId: props.elementId,
            confirmation: {
                rejectDialog: false,
                acceptDialog: false,
                message: undefined,
                title: undefined,
            },
            rejectReason: undefined,
            element: {
                type: this.props.viewMode === ViewMode.NEW ? {enumValue: 'DOMESTIC', label: 'Krajowa'} : undefined,
                delegator: undefined,
                startDate: undefined,
                endDate: undefined,
                delegated: undefined,
                transportModes: undefined,
                destination: undefined,
                destinations: [],
                project: undefined,
                status: {enumValue: DelegationStatus.NEW_REQUEST, label: 'Nowy wniosek'},
                advance: this.initAdvance(),
                notes: undefined,
                startLocation: undefined,
                rejectReason: undefined,
                destinationLocation: undefined,
                crossPolishBorderReturnDate: undefined,
                meals: this.initMeals(),
            },
            advancePaymentEnabled: false,
            paymentTypes: [],
            currencies: [],
            types: [],
            statuses: [],
            projects: [],
            delegators: [],
            delegateds: [],
            countries: [],
            allCountries: [],
            paymentDictionaries: [],
            expenseCategoryDictionaries: [],
        };
        this.settlementItems = this.getSettlementItems();
        this.projectService = new ProjectService();
        this.employeeService = new UsersService();
        this.dictionaryService = new DictionaryService();
        this.countryService = new CountryService();
        this.renderDetails = this.renderDetails.bind(this);
        this.validator.addCustomRule('between_start_end_dates', t('delegation.details.dateMustBeBetweenStartEnd'), (value) => {
            if (StringUtils.isBlank(value)) {
                return true;
            } else {
                if (StringUtils.isBlank(this.state.element?.startDate) || StringUtils.isBlank(this.state.element?.endDate)) {
                    return true;
                }
                const date = DateUtils.dateFromString(value);
                const from = DateUtils.dateFromString(this.state.element?.startDate);
                const to = DateUtils.dateFromString(this.state.element?.endDate);
                if (date >= from && date <= to) {
                    return true;
                }
            }
            return false;
        });
    }
    getSettlementItems = () => {
        const items = [];
        items.push({
            label: t('delegation.diet'),
        });
        items.push({
            label: t('delegation.travelCost'),
        });
        items.push({
            label: t('delegation.summary'),
        });
        return items;
    };

    initAdvance = () => {
        return {
            advanceAmount: {
                value: undefined,
                currency: undefined,
            },
            advancePaymentMethod: undefined,
            advancePurpose: undefined,
        };
    };

    initMeals = () => {
        return {
            breakfasts: undefined,
            dinners: undefined,
            suppers: undefined,
        };
    };

    initActiveState() {
       const settlementParam = this.navigationContext.getAndRemoveCallerParam("settlement");
       if (settlementParam) {
            if (this.canEnabledSettlement()) {
                this.setState({
                    activeIndexTabPanel: 1,
                });
            }
        }
    }

    updateElement(data, afterUpdateCustom) {
        if (data.startDate) {
            data.startDate = moment(data.startDate).toDate();
        }
        if (data.endDate) {
            data.endDate = moment(data.endDate).toDate();
        }
        this.setState(
            {
                element: data,
            },
            () => {
                if (afterUpdateCustom) {
                    afterUpdateCustom();
                }
                this.initAfterSetElement();
            }
        );
    }

    afterUpdateSuccess(response) {
        const {cancelUrl, elementId} = this.props;
        const href = `${cancelUrl}/${elementId}`;
        this.persistMessage('success', '', this.getUpdateSucces(response));
        window.location.href = href;
    }

    initBeforeSetElement() {
        this.getDelegationStatus();
        this.getDelegationType();
        this.getPaymentType();
        this.getCurrencies();
        this.getCountries();
        this.getProjects();
        this.getExpenseCategoryDictionary();
        this.getPaymentDictionary();
        this.readMessage();
    }

    initAfterSetElement() {
        super.initAfterSetElement();
        if (this.state.element?.advance) {
            this.setState({
                advancePaymentEnabled: true,
            });
        }
        this.initActiveState();
    }

    getDelegationType() {
        this.enumService
            .getEnumList('DelegationType')
            .then((types) => {
                this.setState({
                    types,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy typów');
            });
    }
    getDelegationStatus() {
        this.enumService
            .getEnumList('DelegationStatus')
            .then((statuses) => {
                this.setState({
                    statuses,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy typów');
            });
    }
    getPaymentType() {
        this.enumService
            .getEnumList('PaymentMethodType')
            .then((paymentTypes) => {
                this.setState({
                    paymentTypes,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy typów płatności');
            });
    }
    getCountries() {
        this.countryService
            .getAll()
            .then((countries) => {
                const allCountries = structuredClone(countries);
                countries = countries.filter((el) => el.name !== 'Polska');
                this.setState({
                    countries,
                    allCountries: allCountries,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy krajów');
            });
    }
    getCurrencies() {
        this.enumService
            .getEnumList('Currency')
            .then((currencies) => {
                this.setState({
                    currencies: currencies.map((currency) => currency.enumValue),
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy walut');
            });
    }
    getExpenseCategoryDictionary() {
        this.dictionaryService
            .getExpenseCategories()
            .then((expenseCategoryDictionaries) => {
                this.setState({expenseCategoryDictionaries});
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy dostępnych kategorii wydatków');
            });
    }
    getPaymentDictionary() {
        this.dictionaryService
            .getPayments()
            .then((paymentDictionaries) => {
                this.setState({paymentDictionaries});
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy dostępnych rodzajów płatności');
            });
    }
    getProjects(query) {
        this.projectService
            .search(query, 'ACTIVE')
            .then((projects) => {
                this.setState({projects: projects});
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy dostępnych projektów');
            });
    }

    getAllDelegators(query) {
        this.employeeService
            .search(query)
            .then((delegators) => this.setState({delegators: delegators}))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy zlecających');
            });
    }
    getAllDelegateds(query) {
        this.employeeService
            .search(query, null, null, null, null, null, null, 'ROLE_REPORT_OWN_DELEGATION')
            .then((delegateds) => this.setState({delegateds: delegateds}))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy delegowanych');
            });
    }

    prepareFooterItems() {
        const {editUrl, elementId} = this.props;

        const result = super.prepareFooterItems(); // TODO: Do omowienia bo wiedze ze pod spodem generowane sa dwa przyciskiw do zapisywania 
        if (this.canAcceptOrRejectDelegation()) {
            result.push({
                id: 'accept-footer-btn',
                label: 'Akcpetuj wniosek',
                className: 'float-right white',
                onClick: () => this.manageShowDialog(false, true, 'Czy na pewno chcesz zaakceptować wniosek?', 'Akceptuj wniosek'),
            });
            result.push({
                id: 'reject-footer-btn',
                label: 'Odrzuć wniosek',
                className: 'float-right red',
                onClick: () => this.manageShowDialog(true, false, 'Czy na pewno chcesz odrzucić wniosek?', 'Odrzuć wniosek'),
            });
        }
        if (this.canEditDelegation()) {
            result.push({id: 'edit-footer-btn', label: 'Edytuj', className: 'float-right', href: `${editUrl}/${elementId}`});
        }
        if (this.canAcceptOrRejectSettlement()) {
            result.push({
                id: 'accept-footer-btn',
                label: 'Akceptuj rozliczenie',
                className: 'float-right white',
                onClick: () => this.manageShowDialog(false, true, 'Czy na pewno chcesz zaakceptować rozliczenie?', 'Akceptuj rozliczenie'),
            });
            result.push({
                id: 'reject-footer-btn',
                label: 'Odrzuć rozliczenie',
                className: 'float-right red',
                onClick: () => this.manageShowDialog(true, false, 'Czy na pewno chcesz odrzucić rozliczenie?', 'Odrzuć rozliczenie'),
            });
        }
        if (
            !this.isNotMyDelegation() &&
            this.authService.isUserInAnyRole('ROLE_REPORT_OWN_DELEGATION') &&
            this.state.activeSettlementStep === 2
        ) {
            const status = this.state.element?.status?.enumValue;
            if (status === DelegationStatus.AWAITING_SETTLEMENT) {
                result.push({
                    id: 'accept-footer-btn',
                    label: 'Wyślij do akceptacji',
                    className: 'float-right ',
                    onClick: () => this.manageShowDialog(false, true, 'Czy na pewno chcesz wysłać do akceptacji?', 'Wyślij do akceptacji'),
                });
            } else if (status === DelegationStatus.SETTLEMENT_REJECTED) {
                result.push({
                    id: 'reject-footer-btn',
                    label: 'Wyślij ponownie do akceptacji',
                    className: 'float-right ',
                    onClick: () =>
                        this.manageShowDialog(
                            true,
                            false,
                            'Czy na pewno chcesz wysłać ponownie do akceptacji?',
                            'Wyślij ponownie do akceptacji'
                        ),
                });
            }
        }
        return result;
    }

    editableDetailViewStatuses = () => {
        const {element} = this.state;
        return element?.status?.enumValue === DelegationStatus.NEW_REQUEST;
    };

    viewModeForBaseInformation = () => {
        if (this.editableDetailViewStatuses()) {
            return this.props.viewMode;
        }
        return ViewMode.VIEW;
    };

    reject = () => {
        if (this.validator.allValid()) {
            this.service
                .rejectState(this.state.element.id, this.state.rejectReason)
                .then(() => {
                    this.showSuccessMessage(this.getUpdateSucces());
                    this.setElement();
                })
                .catch((ex) => {
                    this.showErrorMessage(ex.message);
                })
                .finally(() => {
                    this.manageShowDialog();
                });
        } else {
            this.validator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    };

    accept = () => {
        this.service
            .acceptState(this.state.element.id)
            .then(() => {
                this.showSuccessMessage(this.getUpdateSucces());
                this.setElement();
            })
            .catch((ex) => {
                this.showErrorMessage(ex.message);
            })
            .finally(() => {
                this.manageShowDialog();
            });
    };

    isPdfButtonRendered() {
        return false;
    }

    getPdfDownloadLabel() {
        return null;
    }

    getUpdateSucces() {
        return t('delegation.updateSuccess');
    }

    getAddSucces() {
        return t('delegation.addSuccess');
    }

    prepareObjectToSave(element) {
        const modifiedElement = structuredClone(element);
        modifiedElement.startDate = modifiedElement.startDate
            ? moment(modifiedElement.startDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME)
            : null;
        modifiedElement.endDate = modifiedElement.endDate
            ? moment(modifiedElement.endDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME)
            : null;
        modifiedElement.crossPolishBorderReturnDate = modifiedElement.crossPolishBorderReturnDate
            ? moment(modifiedElement.crossPolishBorderReturnDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME)
            : null;
        if (!StringUtils.isBlank(element?.advance?.advanceAmount?.value)) {
            modifiedElement.advance.advanceAmount.currency = {enumValue: 'PLN', label: 'PLN'};
        }
        if (Array.isArray(modifiedElement?.destinations)) {
            modifiedElement.destinations.forEach((el) => {
                if (el.startDate) {
                    el.startDate = moment(el.startDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
                }
            });
        }
        if (Array.isArray(modifiedElement?.accommodations)) {
            modifiedElement.accommodations.forEach((el) => {
                if (el.paymentDate) {
                    el.paymentDate = moment(el.paymentDate).format(Constants.DATE_GET_REQUEST_FORMAT);
                }
            });
        }
        if (Array.isArray(modifiedElement?.expenses)) {
            modifiedElement.expenses.forEach((el) => {
                if (el.paymentDate) {
                    el.paymentDate = moment(el.paymentDate).format(Constants.DATE_GET_REQUEST_FORMAT);
                }
            });
        }
        if (Array.isArray(modifiedElement?.expenses)) {
            modifiedElement.expenses.forEach((el) => {
                if (el.paymentDate) {
                    el.paymentDate = moment(el.paymentDate).format(Constants.DATE_GET_REQUEST_FORMAT);
                }
            });
        }
        if (Array.isArray(modifiedElement?.vehicleLogs)) {
            modifiedElement.vehicleLogs.forEach((el) => {
                if (el.departureDate) {
                    el.departureDate = moment(el.departureDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
                }
                if (el.arrivalDate) {
                    el.arrivalDate = moment(el.arrivalDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
                }
            });
        }

        if (!this.state.advancePaymentEnabled) {
            modifiedElement.advance = undefined;
        }
        return modifiedElement;
    }

    createOrUpdate() {
        const element = this.prepareObjectToSave(this.state.element);
        super.createOrUpdate(element);
    }

    destinationTemplate(rowData, props) {
        const {rowIndex} = props;
        const element = rowData;
        return (
            <InputTextComponent
                id={`destination-${rowIndex}`}
                name='destination'
                label='Miejsce docelowe'
                colClass='col-12 destination-destinations'
                value={element?.destination}
                showLabel={false}
                validator={this.validator}
                validators='required|max:1024'
                onChange={this.handleChange}
                viewMode={this.viewModeForBaseInformation()}
                stateField={`element.destinations[${rowIndex}]`}
            />
        );
    }

    indexTemplate(rowData, props) {
        const {rowIndex} = props;
        return (
            <InputTextComponent
                id={`rowIndex-${rowIndex}`}
                name='destination'
                value={rowIndex + 1}
                validator={this.validator}
                viewMode={ViewMode.VIEW}
            />
        );
    }

    countryTemplate(rowData, props) {
        const {rowIndex} = props;
        const element = rowData;
        return (
            <InputDropdownComponent
                id={`country-${rowIndex}`}
                name='country'
                value={element.country}
                stateField={`element.destinations[${rowIndex}]`}
                showLabel={false}
                label='Kraj'
                dataKey='id'
                options={this.state.countries}
                optionLabel='name'
                onChange={this.handleChange}
                insideTable
                viewMode={this.viewModeForBaseInformation()}
                validator={this.validator}
                validators='required'
                colClass='col-12 country-destinations'
                filter
                filterBy='name'
            />
        );
    }
    startDateTemplate(rowData, props) {
        const {rowIndex} = props;
        const endOfValidator =
            rowIndex > 0
                ? `|after_or_equal_date_time~${moment(this.state.element.destinations[rowIndex - 1].startDate)
                      .format(Constants.DATE_TIME_FORMAT_WITHOUT_SEC)
                      .toString()}`
                : '';
        let minDate = undefined;
        if (rowIndex > 0) {
            minDate = new Date(this.state.element.destinations[rowIndex - 1].startDate);
        }
        return (
            <InputCalendarComponent
                id={`startDate-${rowIndex}`}
                colClass='col-12 start-date-destinations'
                name='startDate'
                label='Data przekroczenia granicy kraju'
                dateFormatMoment={Constants.DATE_TIME_FORMAT_WITHOUT_SEC}
                placeholder='DD-MM-YYYY HH:mm'
                value={
                    !StringUtils.isBlank(rowData.startDate) && StringUtils.isString(rowData.startDate)
                        ? new Date(rowData.startDate)
                        : rowData.startDate
                }
                minDate={minDate}
                onChange={this.handleChange}
                viewMode={this.viewModeForBaseInformation()}
                validator={this.validator}
                showTime
                showSeconds={false}
                validators={`required|between_start_end_dates${endOfValidator}`}
                stateField={`element.destinations[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
            />
        );
    }
    isNotMyDelegation() {
        return !UrlUtils.isOnView('my-delegation');
    }

    destinationActionTemplate(rowData, props) {
        const {rowIndex} = props;
        if (rowIndex === 0) {
            return undefined;
        }
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let destinations = this.state.element.destinations.filter((pa) => pa !== rowData);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                destinations,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </span>
        );
    }
    addNewDestination() {
        const {destinations} = this.state.element;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                destinations: destinations.concat({
                    startDate:
                        destinations.length === 0 ? (this.state.element.startDate ? this.state.element.startDate : undefined) : undefined,
                    country: undefined,
                }),
            },
        }));
    }

    manageShowDialog = (rejectDialog = false, acceptDialog = false, message = '', title = '') => {
        this.setState({
            confirmation: {
                rejectDialog,
                acceptDialog,
                message,
                title,
            },
        });
    };

    rejectDialog = () => {
        return (
            <YesNoDialog
                id='confirmation-dialog'
                childrenDivClassname={'empty'}
                visible={this.state.confirmation?.rejectDialog}
                header={this.state.confirmation?.title}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.reject();
                    } else {
                        this.manageShowDialog();
                    }
                }}
                onHide={() => {
                    this.manageShowDialog();
                }}
            >
                <InputTextareaComponent
                    id='rejectReasonFromDialog'
                    name='rejectReason'
                    label={t('delegation.reasonForRejection')}
                    colClass='col-xl-12'
                    value={this.state.rejectReason}
                    validator={this.validator}
                    stateField=''
                    validators='required'
                    onChange={this.handleChange}
                    viewMode={ViewMode.EDIT}
                />
            </YesNoDialog>
        );
    };
    acceptDialog = () => {
        return (
            <YesNoDialog
                id='confirmation-dialog'
                childrenDivClassname={'empty'}
                visible={this.state.confirmation?.acceptDialog}
                header={this.state.confirmation.title}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.accept();
                    } else {
                        this.manageShowDialog();
                    }
                }}
                onHide={() => {
                    this.manageShowDialog();
                }}
            >
                {this.state.confirmation.message}
            </YesNoDialog>
        );
    };
    canViewRejectReason = () => {
        const {element} = this.state;
        return !!(
            element.rejectReason &&
            (element.status?.enumValue === DelegationStatus.REQUEST_REJECTED ||
                element.status?.enumValue === DelegationStatus.SETTLEMENT_REJECTED)
        );
    };
    canAcceptOrRejectSettlement = () => {
        const {element} = this.state;
        return (
            this.isNotMyDelegation() &&
            this.authService.isUserInAnyRole('ROLE_DELEGATION_SETTLEMENT_APPROVE') &&
            element?.status?.enumValue === DelegationStatus.SETTLEMENT_ENTERED &&
            this.state.activeIndexTabPanel === 1
        );
    };

    canAcceptOrRejectDelegation = () => {
        const {element} = this.state;
        return (
            this.authService.isUserInAnyRole('ROLE_DELEGATION_REQUEST_APPROVE') &&
            this.props.viewMode === ViewMode.VIEW &&
            this.editableDetailViewStatuses() &&
            this.isNotMyDelegation() &&
            element?.status?.enumValue === DelegationStatus.NEW_REQUEST
        );
    };

    canEditDelegation = () => {
        return (
            this.authService.isUserInAnyRole('ROLE_REPORT_OWN_DELEGATION', 'ROLE_DELEGATION_EDIT') &&
            this.props.viewMode === ViewMode.VIEW &&
            this.editableDetailViewStatuses()
        );
    };

    canEnabledSettlement = () => {
        const {element} = this.state;
        return (
            element?.status?.enumValue === DelegationStatus.AWAITING_SETTLEMENT ||
            element?.status?.enumValue === DelegationStatus.SETTLEMENT_ENTERED ||
            element?.status?.enumValue === DelegationStatus.SETTLEMENT_REJECTED ||
            element?.status?.enumValue === DelegationStatus.SETTLEMENT_ACCEPTED
        );
    };

    canUpdateSettlementAfterChangeStep = () => {
        const {element} = this.state;
        return element?.status?.enumValue === DelegationStatus.AWAITING_SETTLEMENT && !this.isNotMyDelegation();
    };

    renderDetailsView = () => {
        return (
            <div className='row'>
                <InputDropdownComponent
                    id='type'
                    name='type'
                    label={t('delegation.type')}
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.element.type}
                    validator={this.validator}
                    options={this.state.types}
                    viewMode={this.viewModeForBaseInformation()}
                    onChange={this.handleChange}
                    optionLabel='label'
                    dataKey='enumValue'
                    onAfterStateChange={() => {
                        if (this.state.element.type.enumValue === 'FOREIGN') {
                            this.addNewDestination();
                        } else {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    destinations: [],
                                },
                            }));
                        }
                    }}
                    validators='required'
                    rendered={true}
                    valueView={this.state.element.type ? this.state.element.type?.label : ''}
                />
                <InputDropdownComponent
                    id='status'
                    name='status'
                    label={t('delegation.status')}
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.element.status}
                    validator={this.validator}
                    options={this.state.statuses}
                    viewMode={this.viewModeForBaseInformation()}
                    onChange={this.handleChange}
                    optionLabel='label'
                    disabled
                    dataKey='enumValue'
                    validators='required'
                    rendered={true}
                    valueView={this.state.element.status ? this.state.element.status.label : ''}
                />
                <InputAutocompleteComponent
                    id={`project`}
                    name='project'
                    label={t('delegation.project')}
                    value={this.state.element.project}
                    dropdown
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    forceSelection
                    viewMode={this.viewModeForBaseInformation()}
                    validator={this.validator}
                    validators='required'
                    showLabel={true}
                    onChange={this.handleChange}
                    filteredList={this.state.projects}
                    filterList={(query) => this.getProjects(query)}
                    field='name'
                    minLength={3}
                    placeholder={t('search.project.placeholder')}
                />

                <InputAutocompleteComponent
                    id={`delegator`}
                    name='delegator'
                    label={t('delegation.delegator')}
                    value={this.state.element.delegator}
                    dropdown
                    forceSelection
                    colClass={this.isNotMyDelegation() ? 'col-xl-3 col-lg-6 col-md-6 col-sm-12' : 'col-xl-6 col-lg-6 col-md-6 col-sm-12'}
                    validator={this.validator}
                    validators='not_required'
                    showLabel={true}
                    onChange={this.handleChange}
                    filteredList={this.state.delegators}
                    filterList={(query) => this.getAllDelegators(query)}
                    field='fullName'
                    stateField={`element`}
                    minLength={3}
                    viewMode={this.viewModeForBaseInformation()}
                    placeholder={t('search.users.placeholder')}
                />
                <InputAutocompleteComponent
                    id={`delegated`}
                    name='delegated'
                    label={t('delegation.delegated')}
                    value={this.state.element.delegated}
                    dropdown
                    forceSelection
                    colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                    validator={this.validator}
                    validators='required'
                    showLabel={true}
                    rendered={this.isNotMyDelegation()}
                    onChange={this.handleChange}
                    filteredList={this.state.delegateds}
                    filterList={(query) => this.getAllDelegateds(query)}
                    field='fullName'
                    stateField={`element`}
                    minLength={3}
                    viewMode={this.viewModeForBaseInformation()}
                    placeholder={t('search.users.placeholder')}
                />

                <InputTextComponent
                    id='transportModes'
                    name='transportModes'
                    label={t('delegation.transportModes')}
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.element.transportModes}
                    validator={this.validator}
                    validators='not_required|max:255'
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                />

                <InputTextComponent
                    id='startLocation'
                    name='startLocation'
                    label={t('delegation.startLocation')}
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.element.startLocation}
                    validator={this.validator}
                    validators='not_required|max:255'
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                />

                <InputTextComponent
                    id='destinationLocation'
                    name='destinationLocation'
                    label={t('delegation.destinationLocation')}
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.element.destinationLocation}
                    validator={this.validator}
                    validators='required|max:255'
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                    rendered={this.state.element.type?.enumValue === 'DOMESTIC'}
                />
              {this.state.element.type?.enumValue !== 'DOMESTIC' && <InputCalendarComponent
                    id='crossPolishBorderReturnDate'
                    name='crossPolishBorderReturnDate'
                    label='Data przekrocznia granicy Polski (wjazd)'
                    colClass={'col-xl-6 col-lg-6 col-md-6 col-sm-12'}
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                    validator={this.validator}
                    value={
                        StringUtils.isString(this.state.element?.crossPolishBorderReturnDate)
                            ? new Date(this.state.element?.crossPolishBorderReturnDate)
                            : this.state.element?.crossPolishBorderReturnDate
                    }
                    showIcon
                    showClear
                    placeholder='DD-MM-YYYY HH:mm'
                    showTime={true}
                    rendered={this.state.element.type?.enumValue !== 'DOMESTIC'}
                    validators={'between_start_end_dates'}
                    dateFormatMoment={Constants.DATE_TIME_FORMAT}
                    propCustomValue={true}
                />}  
                <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'></div>
                <InputTextareaComponent
                    id='purpose'
                    name='purpose'
                    label={t('delegation.purpose')}
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.element.purpose}
                    validator={this.validator}
                    validators='required|max:1024'
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                />

                <InputTextareaComponent
                    id='notes'
                    name='notes'
                    label={t('delegation.note')}
                    colClass={'col-xl-6 col-lg-6 col-md-6 col-sm-12'}
                    value={this.state.element.notes}
                    validators={'not_required:max:1024'}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                />

                <InputCalendarRangeComponent
                    id='date'
                    idFrom='startDate'
                    idTo='endDate'
                    nameFrom='startDate'
                    showTime={true}
                    nameTo='endDate'
                    labelFrom={t('delegation.details.startDate')}
                    labelTo={t('delegation.details.endDate')}
                    colClass={'col-12 mb-3'}
                    placeholderFrom='DD-MM-YYYY HH:mm'
                    placeholderTo='DD-MM-YYYY HH:mm'
                    from={this.state.element.startDate}
                    to={this.state.element.endDate}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={this.viewModeForBaseInformation()}
                    showIcon={true}
                    dateFormatMoment={Constants.DATE_TIME_FORMAT}
                    validators={'required'}
                    validatorsToType={''}
                    validatorsTo={'required'}
                />
                <InputCheckboxComponent
                    insideTable={true}
                    labelOnRight={true}
                    id={`advancePaymentEnabled`}
                    name='advancePaymentEnabled'
                    label={'Wniosek o zaliczke'}
                    value={this.state.advancePaymentEnabled}
                    validator={this.validator}
                    validators='not_required'
                    stateField=''
                    disabled={this.viewModeForBaseInformation() === ViewMode.VIEW}
                    onChange={this.handleChange}
                    onAfterStateChange={() => {
                        const shouldBeAdvanceReinitialized =
                            this.state.advancePaymentEnabled && StringUtils.isBlank(this.state.element?.advance);
                        if (shouldBeAdvanceReinitialized) {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    advance: this.initAdvance(),
                                },
                            }));
                        }
                    }}
                    viewMode={ViewMode.EDIT}
                />

                {this.state.advancePaymentEnabled && (
                    <React.Fragment>
                        <InputNumberComponent
                            id={`value-rate`}
                            name='value'
                            label={t('delegation.details.price')}
                            value={this.state.element?.advance?.advanceAmount?.value}
                            stateField={`element.advance.advanceAmount`}
                            onChange={this.handleChange}
                            viewMode={ViewMode.EDIT}
                            min={0}
                            disabled={this.viewModeForBaseInformation() === ViewMode.VIEW}
                            validator={this.validator}
                            validators='required'
                            mode='currency'
                            currency='PLN'
                            locale='pl-PL'
                        />

                        <InputDropdownComponent
                            id='advancePaymentMethod'
                            name='advancePaymentMethod'
                            label={t('delegation.advancePaymentMethod')}
                            colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                            value={this.state.element?.advance?.advancePaymentMethod}
                            validator={this.validator}
                            options={this.state.paymentTypes}
                            viewMode={ViewMode.EDIT}
                            disabled={this.viewModeForBaseInformation() === ViewMode.VIEW}
                            onChange={this.handleChange}
                            optionLabel='label'
                            dataKey='enumValue'
                            stateField='element.advance'
                            validators='required'
                            rendered={true}
                        />
                        <InputTextComponent
                            id='advancePurpose'
                            name='advancePurpose'
                            label={t('delegation.advancePurpose')}
                            colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                            value={this.state.element?.advance?.advancePurpose}
                            validator={this.validator}
                            stateField='element.advance'
                            validators='required|max:512'
                            onChange={this.handleChange}
                            viewMode={ViewMode.EDIT}
                            disabled={this.viewModeForBaseInformation() === ViewMode.VIEW}
                        />
                    </React.Fragment>
                )}
                {this.state.element.type?.enumValue === 'FOREIGN' && (
                    <div>
                        <label className='p-label mt-4'>
                            <h7>Miejsca docelowe</h7>{' '}
                        </label>
                        <DataTable
                            value={this.state.element?.destinations}
                            responsiveLayout='scroll'
                            emptyMessage={t('list.empty')}
                            className=''
                        >
                            <Column field='rowIndex' header='Kolejność' body={this.indexTemplate.bind(this)}></Column>
                            <Column
                                field='country'
                                header='Kraj'
                                style={{minWidth: '200px'}}
                                body={this.countryTemplate.bind(this)}
                            ></Column>
                            <Column
                                field='destination'
                                header='Miejsce docelowe'
                                style={{minWidth: '400px'}}
                                body={this.destinationTemplate.bind(this)}
                            ></Column>

                            <Column
                                field='startDate'
                                header='Data przekroczenia granicy kraju'
                                bodyStyle={{maxWidth: '100px'}}
                                body={(rowData, props) => {
                                    return this.startDateTemplate(rowData, props);
                                }}
                            ></Column>

                            {this.viewModeForBaseInformation() !== ViewMode.VIEW && (
                                <Column header='' body={this.destinationActionTemplate.bind(this)}></Column>
                            )}
                        </DataTable>
                        <DivContainer rendered={this.viewModeForBaseInformation() !== ViewMode.VIEW}>
                            <ActionLink
                                id='add-destination'
                                label={t('delegation.details.addDestination')}
                                iconName='mdi-plus'
                                iconSide='left'
                                iconSize='icon-large'
                                variant='blue'
                                className='float-right'
                                key={'add-activity-button'}
                                handleClick={this.addNewDestination.bind(this)}
                            />
                        </DivContainer>
                    </div>
                )}
                <InputTextareaComponent
                    id='rejectReason'
                    name='rejectReason'
                    label={t('delegation.reasonForRejection')}
                    colClass='col-12 mt-2 mb-2'
                    rendered={this.canViewRejectReason()}
                    value={this.state.element.rejectReason}
                    validators={'not_required:max:1024'}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={ViewMode.VIEW}
                />
            </div>
        );
    };

    renderSettlementsView = () => {
        const getAvailableCountries = () => {
            const filteredCountries = this.state.allCountries.filter((country) => {
                const countries = this.state.element.destinations.map((e) => e.country.name);
                return countries.includes(country.name);
            });
            const poland = this.state.allCountries.find((el) => el.name === 'Polska');
            filteredCountries.push(poland);
            return filteredCountries;
        };
        switch (this.state?.activeSettlementStep) {
            case 0:
                return (
                    <DelegationDietStep
                        element={this.state.element}
                        validator={this.validator}
                        setFullBoard={(checked, destinationId) => {
                            const meals = checked ? null : this.initMeals();
                            if (StringUtils.isBlank(destinationId)) {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        meals: meals,
                                    },
                                }));
                            } else {
                                const destinations = this.state.element.destinations;
                                destinations.forEach((destination) => {
                                    if (parseInt(destination.id) === parseInt(destinationId)) destination.meals = meals;
                                });
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        destinations: destinations,
                                    },
                                }));
                            }
                        }}
                        viewMode={this.viewModeForSettlementInputs()}
                        handleChange={this.handleChange}
                    />
                );
            case 1:
                return (
                    <DelegationTravelCostStep
                        updateElement={(element) => {
                            this.setState({
                                element,
                            });
                        }}
                        errorMessage={this.showErrorMessage}
                        currencies={this.state.currencies}
                        paymentDictionaries={this.state.paymentDictionaries}
                        expenseCategoryDictionaries={this.state.expenseCategoryDictionaries}
                        countries={getAvailableCountries()}
                        element={this.state.element}
                        validator={this.validator}
                        viewMode={this.viewModeForSettlementInputs()}
                        handleChange={this.handleChange}
                    />
                );
            default:
                return (
                    <DelegationSummaryStep
                        initViewMode={this.viewModeForSummaryInputs()}
                        element={this.state.element}
                        validator={this.validator}
                        handleChange={this.handleChange}
                    />
                );
        }
    };

    viewModeForSummaryInputs() {
        if (this.state.editRefund) {
            return ViewMode.EDIT;
        }
        return ViewMode.VIEW;
    }

    viewModeForSettlementInputs() {
        const {element} = this.state;
        if (this.isNotMyDelegation()) {
            return ViewMode.VIEW;
        }
        if (
            (element?.status?.enumValue === DelegationStatus.SETTLEMENT_REJECTED ||
                element?.status?.enumValue === DelegationStatus.AWAITING_SETTLEMENT) &&
            this.authService.isUserInAnyRole('ROLE_REPORT_OWN_DELEGATION')
        ) {
            return ViewMode.EDIT;
        }
        return ViewMode.VIEW;
    }

    getEditRefund = () => {
        if (this.canAcceptOrRejectSettlement()) {
            return (
                <React.Fragment>
                    {this.state.editRefund ? (
                        <ActionButton
                            id={'save-cost'}
                            handleClick={(e) => {
                                this.setState({editRefund: false}, () => {
                                    this.service
                                        .summaryEnter(this.state.element.id, this.state.element.summary)
                                        .then(() => {})
                                        .catch((err) => {
                                            this.handleGetDetailsError(err);
                                        });
                                });
                            }}
                            label={t('Zapisz koszta')}
                        />
                    ) : (
                        <ActionButton
                            id={'edit-cost'}
                            handleClick={(e) => {
                                this.setState({editRefund: true});
                            }}
                            label={t('Edytuj koszta')}
                        />
                    )}
                </React.Fragment>
            );
        }
        return null;
    };
    renderStepper = () => {
        return (
            <StepperComponent
                activeStep={this.state.activeSettlementStep}
                lastStepButton={() => this.getEditRefund()}
                onChangeActiveStep={(activeStep) => {
                    const {viewMode} = this.props;
                    const {elementId} = this.state;
                    this.service
                        .get(elementId, viewMode)
                        .then((data) => {
                            this.updateElement(data, () => {
                                this.setState({
                                    editRefund: false,
                                    activeSettlementStep: activeStep,
                                });
                            });
                        })
                        .catch((err) => {
                            this.handleGetDetailsError(err);
                        });
                }}
                preChangeStep={(changeStep) => {
                    if (this.canUpdateSettlementAfterChangeStep()) {
                        if (this.validator.allValid()) {
                            const element = this.prepareObjectToSave(this.state.element);
                            this.service
                                .updateMySettlement(element)
                                .then(() => {
                                    changeStep();
                                })
                                .catch((err) => {
                                    this.showErrorMessage(err.message, 10000);
                                    this.unblockUi();
                                })
                                .finally(() => {
                                    this.unblockUi();
                                });
                        } else {
                            this.validator.showMessages();
                            this.scrollToError = true;
                            this.forceUpdate();
                        }
                    } else {
                        changeStep();
                    }
                }}
                component={() => (
                    <React.Fragment>
                        <InputDropdownComponent
                            id='type'
                            name='type'
                            colClass='col-xl-3 col-lg-12 col-md-12 col-sm-12 mt-2 mb-2'
                            value={this.state.element.type}
                            validator={this.validator}
                            options={this.state.types}
                            viewMode={'EDIT'}
                            disabled
                            onChange={this.handleChange}
                            optionLabel='label'
                            dataKey='enumValue'
                            validators='required'
                            rendered={true}
                            valueView={this.state.element.type ? this.state.element.type?.label : ''}
                        />
                        {this.renderSettlementsView()}
                        <div className='mb-4'></div>
                    </React.Fragment>
                )}
                outsideClassName
                stepClassName={'mb-2 mt-2'}
                model={this.settlementItems}
            />
        );
    };
    renderDetails() {
        return (
            <React.Fragment>
                {this.state.confirmation?.rejectDialog && this.rejectDialog()}
                {this.state.confirmation?.acceptDialog && this.acceptDialog()}
                <div className='row'>
                    <TabView
                        style={{marginLeft: ''}}
                        activeIndex={this.state.activeIndexTabPanel}
                        onTabChange={(e) => {
                            this.setElement();
                            this.setState({
                                activeIndexTabPanel: e.index,
                            });
                        }}
                    >
                        <TabPanel className='tab-detail' header={<div>Szczegóły</div>}>
                            {this.renderDetailsView()}
                        </TabPanel>
                        {this.props.viewMode !== ViewMode.NEW && (
                            <TabPanel
                                disabled={!this.canEnabledSettlement()}
                                id='tab-settlements'
                                className='tab-settlements'
                                header={<div>Rozliczenia</div>}
                            >
                                {this.renderStepper()}
                            </TabPanel>
                        )}
                    </TabView>
                </div>
            </React.Fragment>
        );
    }
}

DelegationContainer.defaultProps = {
    backUrl: '/#/delegation-list',
    cancelUrl: '/#/delegation/details',
    editUrl: '/#/delegation/edit',
};

DelegationContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(DelegationContainer);